import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { processSessionId } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        setStatus('authenticating');
        
        const success = await processSessionId(sessionId);
        
        if (success) {
          setStatus('success');
          // Clear the hash and do a full page redirect to ensure state is fresh
          // This ensures the navbar and all components re-render with the new user
          setTimeout(() => {
            window.location.href = window.location.origin;
          }, 500);
        } else {
          setStatus('error');
          setTimeout(() => {
            window.location.href = window.location.origin;
          }, 2000);
        }
      } else {
        // No session_id, redirect to home
        window.location.href = window.location.origin;
      }
    };

    handleCallback();
  }, [processSessionId]);

  return (
    <div className="min-h-screen bg-[#0f0a1a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">
          {status === 'processing' && 'Processing...'}
          {status === 'authenticating' && 'Signing you in...'}
          {status === 'success' && 'Welcome! Redirecting...'}
          {status === 'error' && 'Something went wrong. Redirecting...'}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
